import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=4b7c86d2&scoped=true&"
import script from "./BillingPage.vue?vue&type=script&lang=js&"
export * from "./BillingPage.vue?vue&type=script&lang=js&"
import style0 from "./BillingPage.vue?vue&type=style&index=0&id=4b7c86d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c86d2",
  null
  
)

export default component.exports